import { ISchema, PaywallComponentProps } from '../../@types'
import { mergeDeep, round } from '@/helpers/utils'

export default (schema: ISchema): ISchema => {
	const baseBillingModal = schema.components?.PaywallBillingModal

	return mergeDeep(
		{
			...schema,
			order: schema.order?.map((name) => (name === 'PaywallPlanPickerComp' ? 'PaywallPlanPicker' : name)),
		},
		{
			components: {
				PaywallPlanPicker: ({ $t, ctx }): PaywallComponentProps.PlanPicker => ({
					theme: 'price-shape',
					borderRadius: 16,
					items: [
						{
							title: $t('female_yoga.pages.paywall.plans.1_week.plan_name'),
							subtitle: ctx.removeDiscount ? '{trial_price}' : '<s>{trial_original_price}</s> → {trial_price}',
							rightPriceType: 'per-day-shape',
						},
						{
							title: $t('female_yoga.pages.paywall.plans.4_weeks.plan_name'),
							subtitle: ctx.removeDiscount ? '{trial_price}' : '<s>{trial_original_price}</s> → {trial_price}',
							rightPriceType: 'per-day-shape',
							saveBadge: ctx.removeDiscount
								? undefined
								: {
										text: $t('activity_upgrade.discount_badge', { discountAmount: '{promocode_discount}' }),
										position: 'corner',
									},
							badge: {
								theme: 'full-width',
								text: $t('pages.program.cheap_and_short.common.planPicker.mostPopular'),
								uppercase: true,
							},
						},
						{
							title: $t('female_yoga.pages.paywall.plans.12_weeks.plan_name'),
							subtitle: ctx.removeDiscount ? '{trial_price}' : '<s>{trial_original_price}</s> → {trial_price}',
							rightPriceType: 'per-day-shape',
							saveBadge: ctx.removeDiscount
								? undefined
								: {
										text: $t('activity_upgrade.discount_badge', { discountAmount: '{promocode_discount}' }),
										position: 'corner',
									},
						},
					],
				}),
				PaywallBillingModal: (args): PaywallComponentProps.BillingModal => {
					const { ctx, $t, $tp } = args
					const originalPrice = ctx.selectedProduct?.product?.trial?.originalPrice
					const promocodeDiscount = $tp(
						round(ctx.selectedProduct?.product?.trial?.promocodeDiscount ?? 0),
						ctx.currency,
					)

					return {
						...baseBillingModal?.(args),
						selectedProduct: ctx.selectedProduct,
						inlineContent: {
							alert: {
								text: $t('female_yoga.pages.paywall.billing_modal.discount_alert_text', {
									discount: promocodeDiscount,
								}),
							},
							subtitle: {
								text:
									ctx.removeDiscount || !originalPrice
										? '{trialPrice}'
										: `<s>${$tp(originalPrice, ctx.currency)}</s> → {trialPrice}`,
							},
						},
					}
				},
			},
		},
	)
}
